export default __webpack_public_path__ + "static/media/12-15.d0d3d215.png";